import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import {
  LANDMARKS_ACTIVE,
  LANDMARKS_CATEGORY_LANDMARK,
} from '../../../../component/management-tab/landmarks-sub-tab/landmarks-routing.constants';
import { DevicesManagerService } from '../../../../services/devices-manager.service';
import LandmarksService from '../../../../services/landmarks.service';
import { PermissionService } from '../../../../services/permission.service';

import { MatIcon } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { LandmarkCardComponent } from '../../card/landmark-card/landmark-card.component';
import { WidgetLoaderComponent } from '../widget-loader/widget-loader.component';

@Component({
  selector: 'widget-poi',
  templateUrl: './widget-poi.component.html',
  styleUrls: ['./widget-poi.component.scss'],

  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [LandmarkCardComponent, WidgetLoaderComponent, MatTooltipModule, TranslatePipe, MatIcon],
})
export class WidgetPoiComponent {
  private _devicesManagerService = inject(DevicesManagerService);
  public router = inject(Router);
  public permissionService = inject(PermissionService);
  private _landmarksService = inject(LandmarksService);
  @Input() isDashboard: boolean;
  public $activeLandmarks = this._landmarksService.$activeLandmarks;
  public $devicesMap = this._devicesManagerService.$devicesMap;

  public goToPoiActive() {
    this.router.navigate([LANDMARKS_ACTIVE]);
  }

  public navigateToLandmark(uid: number, uid_category: number) {
    this.router.navigate([LANDMARKS_CATEGORY_LANDMARK(uid_category, uid)], { queryParams: { view: 'map' } });
  }
}
